module.exports = __webpack_public_path__ + "static/stethoscope-c0b1ebf5f4281a76e2413688446bc1d7.png";